class ArchiveCase {
  constructor(el, opt) {
    this.el = el;
    if ($('.' + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    this.articleImageSwiper();
    this.modalSwiper();
  }

  modalSwiper() {
    const swiperEle = '.js-case-modal-swiper';
    let modalSwiper = new Swiper(swiperEle, {
      loop: false,
      autoHeight: true,
      allowTouchMove: false,
      navigation: {
        nextEl: '.js-case-modal-swiper__next',
        prevEl: '.js-case-modal-swiper__prev',
      },
    })

    const slideMoveEle = document.querySelectorAll('.js-case-modal-to');
    slideMoveEle.forEach((item, key) => {
      item.addEventListener('click', () => {
        modalSwiper.slideTo(key, 0);
      })
    })
  }

  articleImageSwiper() {
    const swiperElements = document.querySelectorAll('.js-case-detail-image-swiper');
    swiperElements.forEach((item, index) => {
      // 各スワイパーにユニークなページネーションクラスを付与
      const paginationClass = `swiper-pagination-${index}`;
      const paginationElement = item.nextElementSibling;
      paginationElement.classList.add(paginationClass);

      const prevClass = `swiper-prev-${index}`;
      const nextClass = `swiper-next-${index}`;
      item.querySelector('.js-case-detail-image-swiper__prev').classList.add(prevClass);
      item.querySelector('.js-case-detail-image-swiper__next').classList.add(nextClass);

      new Swiper(item, {
        allowTouchMove: false,
        navigation: {
          prevEl: `.${prevClass}`,
          nextEl: `.${nextClass}`
        },
        pagination: {
          el: `.${paginationClass}`,  // ユニークなページネーションクラスを参照
          clickable: true,
          renderBullet: function (index, className) {
            const slides = this.slides;
            const slide = slides[index];
            const slideImage = slide.querySelector('img').src;  // スライドの画像URLを取得
            return `<div class="${className}"><img src="${slideImage}" ></div>`;
          },
        },
      });
    });
  }


}

